import { useNavigate } from 'react-router';
import { useEffect } from 'react';
import * as Sentry from '@sentry/react';

import { useOrganisations } from './useOrganisations';
import { useRouteOrganisationId } from './useRouteOrganisationId';

export function useGetSelectedOrganisation() {
  const { organisationId, isOverridden } = useRouteOrganisationId();

  useEffect(() => {
    Sentry.setTag(`organisationId`, organisationId);
  }, [organisationId]);

  const nav = useNavigate();
  const { data: organisations } = useOrganisations();

  const organisation = organisations.find(x => x.id === organisationId);

  // An overridden org (e.g. a disconnected org on the reports page) must not redirect the current page
  if (!organisation && organisationId && !isOverridden && organisations.length > 0) {
    // We have connected orgs, but the url doesnt match any, must be a 404
    // redirect them to any org
    nav(`/${organisations[0].id}`);

    return organisations[0];
  }

  return organisation;
}
